import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';
import { EDeliveryType } from '@r1-frontend/service-engineer-visit/types/EDeliveryType';

const getWithInstallValue = (state: TInitialState): number => {
    if (state.deliveryOptions && state.selected.deliveryOption) {
        return Number(state.selected.deliveryOption.name === EDeliveryType.deliveryAndSetup);
    } else {
        return 1;
    }
};

export default getWithInstallValue;
